<script lang="ts">
export default defineComponent({
  props: {
    as: { type: String, default: 'button' }
  },
  setup({ as }, { slots, attrs }) {
    const { isOpen, toggle } = assertInject(DisclosureInjection)

    return () =>
      h(
        as,
        {
          ...attrs,
          'aria-expanded': isOpen.value,
          onClick: toggle
        },
        slots.default!()
      )
  }
})
</script>
